export const get_seconds_precise = () => {
  return (window.performance.now() / 1000);
}
